export const getParameterByName = (name, url = window.location.href) => {
    const param = name.replace(/[[\]]/g, '\\$&');

    const regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const retrieveBackUrl = (location) => {
    const urlParams = {};
    location.search.substr(1).split('&').forEach(pair => {
        const keyValue = pair.split('=');
        urlParams[keyValue[0]] = keyValue[1];
    });

    if (typeof urlParams.backurl !== 'undefined') {
        return urlParams.backurl;
    }

    return false;
};
